import { render, staticRenderFns } from "./AdvancedTab.vue?vue&type=template&id=2d9347b5&scoped=true&"
import script from "./AdvancedTab.vue?vue&type=script&lang=js&"
export * from "./AdvancedTab.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedTab.vue?vue&type=style&index=0&id=2d9347b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9347b5",
  null
  
)

export default component.exports